import { render } from "./RateModal.vue?vue&type=template&id=9df220e2&scoped=true"
import script from "./RateModal.vue?vue&type=script&lang=js"
export * from "./RateModal.vue?vue&type=script&lang=js"

import "./RateModal.vue?vue&type=style&index=0&id=9df220e2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df220e2"]])

export default __exports__